import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, UrlTree } from '@angular/router';

import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

import { ViMonitorService } from '../services/vi-monitor.service';
import { ViRoutingService } from '../services/vi-routing.service';

@Injectable()
export class ViMonitorEditableGuard implements CanActivate {
    constructor(
        private viMonitorService: ViMonitorService,
        private viRoutingService: ViRoutingService
    ) {}

    /**
     * Setup is only editable while a monitor is a draft. Once it goes live,
     * send the user to its results instead of a form they can't submit.
     */
    canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
        const id: number = +route.paramMap.get('id');

        if (!id || isNaN(id)) {
            return of(this.viRoutingService.hypeUrl());
        }

        return this.viMonitorService.getById(id).pipe(
            map(monitor => {
                if (!monitor) {
                    return this.viRoutingService.hypeUrl();
                }

                return monitor.isEditable
                    ? true
                    : this.viRoutingService.resultsUrl(id);
            }),
            catchError(() => of(this.viRoutingService.hypeUrl()))
        );
    }
}
